// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function fare_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var fare = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "fare"), null));
  if (fare.TAG === /* Ok */0) {
    var min_paytm_amount = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "min_paytm_amount"), null));
    if (min_paytm_amount.TAG === /* Ok */0) {
      var min_paytm_amount_with_credits = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "min_paytm_amount_with_credits"), null));
      if (min_paytm_amount_with_credits.TAG === /* Ok */0) {
        var applied_coupon = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "applied_coupon"), null));
        if (applied_coupon.TAG === /* Ok */0) {
          var subscription_discount = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "subscription_discount"), null));
          if (subscription_discount.TAG === /* Ok */0) {
            var total_discount = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "total_discount"), null));
            if (total_discount.TAG === /* Ok */0) {
              var description = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
              if (description.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          fare: fare._0,
                          min_paytm_amount: min_paytm_amount._0,
                          min_paytm_amount_with_credits: min_paytm_amount_with_credits._0,
                          applied_coupon: applied_coupon._0,
                          subscription_discount: subscription_discount._0,
                          total_discount: total_discount._0,
                          description: description._0
                        }
                      };
              }
              var e = description._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".description" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = total_discount._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".total_discount" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = subscription_discount._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".subscription_discount" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = applied_coupon._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".applied_coupon" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = min_paytm_amount_with_credits._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".min_paytm_amount_with_credits" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = min_paytm_amount._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".min_paytm_amount" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = fare._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".fare" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function fare_breakup_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var field_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "field_type"), null));
  if (field_type.TAG === /* Ok */0) {
    var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
    if (title.TAG === /* Ok */0) {
      var subtext = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "subtext"), null));
      if (subtext.TAG === /* Ok */0) {
        var value = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
        if (value.TAG === /* Ok */0) {
          var payable_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "payable_type"), null));
          if (payable_type.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      field_type: field_type._0,
                      title: title._0,
                      subtext: subtext._0,
                      value: value._0,
                      payable_type: payable_type._0
                    }
                  };
          }
          var e = payable_type._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".payable_type" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = value._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".value" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = subtext._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".subtext" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = title._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".title" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = field_type._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".field_type" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function bill_details_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var fare_breakup = Decco.listFromJson((function (param) {
          return Decco.arrayFromJson(fare_breakup_decode, param);
        }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "fare_breakup"), null));
  if (fare_breakup.TAG === /* Ok */0) {
    var net_fare = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "net_fare"), null));
    if (net_fare.TAG === /* Ok */0) {
      var previous_dues = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "previous_dues"), null));
      if (previous_dues.TAG === /* Ok */0) {
        var porter_gold_fee = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "porter_gold_fee"), null));
        if (porter_gold_fee.TAG === /* Ok */0) {
          var porter_credits_applied = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "porter_credits_applied"), null));
          if (porter_credits_applied.TAG === /* Ok */0) {
            var amount_payable = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "amount_payable"), null));
            if (amount_payable.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        fare_breakup: fare_breakup._0,
                        net_fare: net_fare._0,
                        previous_dues: previous_dues._0,
                        porter_gold_fee: porter_gold_fee._0,
                        porter_credits_applied: porter_credits_applied._0,
                        amount_payable: amount_payable._0
                      }
                    };
            }
            var e = amount_payable._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".amount_payable" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = porter_credits_applied._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".porter_credits_applied" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = porter_gold_fee._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".porter_gold_fee" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = previous_dues._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".previous_dues" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = net_fare._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".net_fare" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = fare_breakup._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".fare_breakup" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

function subscription_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var status = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
  if (status.TAG === /* Ok */0) {
    var field_type = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "field_type"), null));
    if (field_type.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                status: status._0,
                field_type: field_type._0
              }
            };
    }
    var e = field_type._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".field_type" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = status._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".status" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function service_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var is_enabled = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_enabled"), null));
  if (is_enabled.TAG === /* Ok */0) {
    var field_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "field_type"), null));
    if (field_type.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                is_enabled: is_enabled._0,
                field_type: field_type._0
              }
            };
    }
    var e = field_type._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".field_type" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = is_enabled._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".is_enabled" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function value_added_services_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var field_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "field_type"), null));
  if (field_type.TAG === /* Ok */0) {
    var off_messages = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "off_messages"), null));
    if (off_messages.TAG === /* Ok */0) {
      var services = Decco.arrayFromJson(service_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "services"), null));
      if (services.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  field_type: field_type._0,
                  off_messages: off_messages._0,
                  services: services._0
                }
              };
      }
      var e = services._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".services" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = off_messages._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".off_messages" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = field_type._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".field_type" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function vehicle_wise_quotation_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var vehicle_id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle_id"), null));
  if (vehicle_id.TAG === /* Ok */0) {
    var quotation_uuid = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "quotation_uuid"), null));
    if (quotation_uuid.TAG === /* Ok */0) {
      var fare_info = Decco.optionFromJson(fare_info_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "fare_info"), null));
      if (fare_info.TAG === /* Ok */0) {
        var bill_details = Decco.optionFromJson(bill_details_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "bill_details"), null));
        if (bill_details.TAG === /* Ok */0) {
          var subscription_info = subscription_info_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "subscription_info"), null));
          if (subscription_info.TAG === /* Ok */0) {
            var book_cta_info_text = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "book_cta_info_text"), null));
            if (book_cta_info_text.TAG === /* Ok */0) {
              var value_added_services = Decco.arrayFromJson(value_added_services_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "value_added_services"), null));
              if (value_added_services.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          vehicle_id: vehicle_id._0,
                          quotation_uuid: quotation_uuid._0,
                          fare_info: fare_info._0,
                          bill_details: bill_details._0,
                          subscription_info: subscription_info._0,
                          book_cta_info_text: book_cta_info_text._0,
                          value_added_services: value_added_services._0
                        }
                      };
              }
              var e = value_added_services._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".value_added_services" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = book_cta_info_text._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".book_cta_info_text" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = subscription_info._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".subscription_info" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = bill_details._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".bill_details" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = fare_info._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".fare_info" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = quotation_uuid._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".quotation_uuid" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = vehicle_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".vehicle_id" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function paytm_wallet_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var login_status = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "login_status"), null));
  if (login_status.TAG === /* Ok */0) {
    var balance = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "balance"), null));
    if (balance.TAG === /* Ok */0) {
      var balance_api_status = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "balance_api_status"), null));
      if (balance_api_status.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  login_status: login_status._0,
                  balance: balance._0,
                  balance_api_status: balance_api_status._0
                }
              };
      }
      var e = balance_api_status._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".balance_api_status" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = balance._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".balance" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = login_status._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".login_status" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function porter_wallet_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var amount = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "amount"), null));
  if (amount.TAG === /* Ok */0) {
    var payable = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "payable"), null));
    if (payable.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                amount: amount._0,
                payable: payable._0
              }
            };
    }
    var e = payable._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".payable" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = amount._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".amount" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function wallet_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var paytm_wallet = paytm_wallet_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "paytm_wallet"), null));
  if (paytm_wallet.TAG === /* Ok */0) {
    var porter_wallet = porter_wallet_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "porter_wallet"), null));
    if (porter_wallet.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                paytm_wallet: paytm_wallet._0,
                porter_wallet: porter_wallet._0
              }
            };
    }
    var e = porter_wallet._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".porter_wallet" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = paytm_wallet._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".paytm_wallet" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function latLng_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var lat = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "lat"), null));
  if (lat.TAG === /* Ok */0) {
    var $$long = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "long"), null));
    if ($$long.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                lat: lat._0,
                long: $$long._0
              }
            };
    }
    var e = $$long._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".long" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = lat._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".lat" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function nearby_vehicle_drivers_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var show_vehicle = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "show_vehicle"), null));
  if (show_vehicle.TAG === /* Ok */0) {
    var vehicle_id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle_id"), null));
    if (vehicle_id.TAG === /* Ok */0) {
      var eta_mins = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "eta_mins"), null));
      if (eta_mins.TAG === /* Ok */0) {
        var booking_enabled = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "booking_enabled"), null));
        if (booking_enabled.TAG === /* Ok */0) {
          var booking_disabled_msg = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "booking_disabled_msg"), null));
          if (booking_disabled_msg.TAG === /* Ok */0) {
            var book_till_x_mins = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "book_till_x_mins"), null));
            if (book_till_x_mins.TAG === /* Ok */0) {
              var show_vehicle_availability_text = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "show_vehicle_availability_text"), null));
              if (show_vehicle_availability_text.TAG === /* Ok */0) {
                var dil_uuid = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "dil_uuid"), null));
                if (dil_uuid.TAG === /* Ok */0) {
                  var driver_locs = Decco.arrayFromJson(latLng_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "driver_locs"), null));
                  if (driver_locs.TAG === /* Ok */0) {
                    return {
                            TAG: /* Ok */0,
                            _0: {
                              show_vehicle: show_vehicle._0,
                              vehicle_id: vehicle_id._0,
                              eta_mins: eta_mins._0,
                              booking_enabled: booking_enabled._0,
                              booking_disabled_msg: booking_disabled_msg._0,
                              book_till_x_mins: book_till_x_mins._0,
                              show_vehicle_availability_text: show_vehicle_availability_text._0,
                              dil_uuid: dil_uuid._0,
                              driver_locs: driver_locs._0
                            }
                          };
                  }
                  var e = driver_locs._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".driver_locs" + e.path,
                            message: e.message,
                            value: e.value
                          }
                        };
                }
                var e$1 = dil_uuid._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".dil_uuid" + e$1.path,
                          message: e$1.message,
                          value: e$1.value
                        }
                      };
              }
              var e$2 = show_vehicle_availability_text._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".show_vehicle_availability_text" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                      }
                    };
            }
            var e$3 = book_till_x_mins._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".book_till_x_mins" + e$3.path,
                      message: e$3.message,
                      value: e$3.value
                    }
                  };
          }
          var e$4 = booking_disabled_msg._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".booking_disabled_msg" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
        }
        var e$5 = booking_enabled._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".booking_enabled" + e$5.path,
                  message: e$5.message,
                  value: e$5.value
                }
              };
      }
      var e$6 = eta_mins._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".eta_mins" + e$6.path,
                message: e$6.message,
                value: e$6.value
              }
            };
    }
    var e$7 = vehicle_id._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".vehicle_id" + e$7.path,
              message: e$7.message,
              value: e$7.value
            }
          };
  }
  var e$8 = show_vehicle._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".show_vehicle" + e$8.path,
            message: e$8.message,
            value: e$8.value
          }
        };
}

function porter_gold_details_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var is_cancellable = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_cancellable"), null));
  if (is_cancellable.TAG === /* Ok */0) {
    var benefits = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "benefits"), null));
    if (benefits.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                is_cancellable: is_cancellable._0,
                benefits: benefits._0
              }
            };
    }
    var e = benefits._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".benefits" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = is_cancellable._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".is_cancellable" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var route_polyline = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "route_polyline"), null));
  if (route_polyline.TAG === /* Ok */0) {
    var vehicle_wise_quotations = Decco.arrayFromJson(vehicle_wise_quotation_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle_wise_quotations"), null));
    if (vehicle_wise_quotations.TAG === /* Ok */0) {
      var wallet_info = wallet_info_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "wallet_info"), null));
      if (wallet_info.TAG === /* Ok */0) {
        var nearby_vehicle_drivers = Decco.arrayFromJson(nearby_vehicle_drivers_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "nearby_vehicle_drivers"), null));
        if (nearby_vehicle_drivers.TAG === /* Ok */0) {
          var select_vehicle_id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "select_vehicle_id"), null));
          if (select_vehicle_id.TAG === /* Ok */0) {
            var porter_gold_details = porter_gold_details_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "porter_gold_details"), null));
            if (porter_gold_details.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        route_polyline: route_polyline._0,
                        vehicle_wise_quotations: vehicle_wise_quotations._0,
                        wallet_info: wallet_info._0,
                        nearby_vehicle_drivers: nearby_vehicle_drivers._0,
                        select_vehicle_id: select_vehicle_id._0,
                        porter_gold_details: porter_gold_details._0
                      }
                    };
            }
            var e = porter_gold_details._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".porter_gold_details" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = select_vehicle_id._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".select_vehicle_id" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = nearby_vehicle_drivers._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".nearby_vehicle_drivers" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = wallet_info._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".wallet_info" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = vehicle_wise_quotations._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".vehicle_wise_quotations" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = route_polyline._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".route_polyline" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

export {
  fare_info_decode ,
  fare_breakup_decode ,
  bill_details_decode ,
  subscription_info_decode ,
  service_decode ,
  value_added_services_decode ,
  vehicle_wise_quotation_decode ,
  paytm_wallet_decode ,
  porter_wallet_decode ,
  wallet_info_decode ,
  latLng_decode ,
  nearby_vehicle_drivers_decode ,
  porter_gold_details_decode ,
  t_decode ,
  
}
/* No side effect */
